// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled, { css } from 'styled-components';
import { Link } from '@helpcenter/analytics-components/src/link';
import { newElevationsFromDesignSystems } from '@helpcenter/styles/src/elevation';
import * as mixins from '@helpcenter/styles/src/mixins';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { token } from '@atlaskit/tokens';

const HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const isHcAdsDropCommit2Enabled = (): boolean => FeatureGates.checkGate(HC_ADS_DROP_COMMIT_2);

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const linkCardBase = css`
	${mixins.raiseUpOnHoverOrFocus(
		newElevationsFromDesignSystems.e100,
		newElevationsFromDesignSystems.e200,
	)};
	${mixins.borderRadius};
	${() => isHcAdsDropCommit2Enabled() && mixins.borderRadiusLarge}
	${mixins.focusRing.default};
	display: block;
	background-color: ${token('elevation.surface.raised', '#FFFFFF')};

	:hover,
	:focus {
		text-decoration: none;
	}
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const LinkCard = styled(Link)`
	${linkCardBase};
`;
